import { render, staticRenderFns } from "./graduates.vue?vue&type=template&id=c01d3848&"
import script from "./graduates.vue?vue&type=script&lang=js&"
export * from "./graduates.vue?vue&type=script&lang=js&"
import style0 from "./graduates.vue?vue&type=style&index=0&id=c01d3848&prod&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {GraduatesSearchSkeleton: require('/opt/buildhome/repo/components/graduates/GraduatesSearchSkeleton.vue').default,GraduateCard: require('/opt/buildhome/repo/components/graduates/GraduateCard.vue').default,ScrollToTop: require('/opt/buildhome/repo/components/utils/ScrollToTop.vue').default})
